import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../../../../../locales';
import './styles.css';

const LanguageContent = ({ selectedLanguage, onLanguageChange }) => {
  const { t, i18n } = useTranslation('settings');

  const languages = [
    { code: 'fr', label: t('pages.preferences.language.options.french') },
    { code: 'en', label: t('pages.preferences.language.options.english') }
  ];

  const handleLanguageChange = async (code) => {
    try {
      console.log('Changement de langue demandé vers:', code);
      
      // Mettre à jour les préférences (cela déclenche la persistance Firestore)
      onLanguageChange(code);
      
      // Appliquer immédiatement le changement dans l'interface
      const success = await changeLanguage(code);
      
      if (success) {
        console.log('Langue changée avec succès vers:', code);
        // Nous utilisons un rechargement minimal pour nous assurer que toutes les traductions sont appliquées
        // (Ce n'est pas toujours nécessaire mais c'est plus sûr)
        setTimeout(() => {
          if (i18n.language !== code) {
            console.log('Langue pas encore mise à jour, forçage...');
            i18n.changeLanguage(code);
          }
        }, 100);
      } else {
        console.error('Échec du changement de langue vers:', code);
      }
    } catch (error) {
      console.error('Erreur lors du changement de langue:', error);
    }
  };

  return (
    <div className="preferences-section">
      <p className="preferences-section-description">
        {t('pages.preferences.language.description')}
      </p>
      <div className="preferences-options-list">
        {languages.map((language) => (
          <button
            key={language.code}
            className={`preferences-option ${
              selectedLanguage === language.code ? 'preferences-option-selected' : ''
            }`}
            onClick={() => handleLanguageChange(language.code)}
          >
            <span className="preferences-option-label">{language.label}</span>
            {selectedLanguage === language.code && (
              <span className="preferences-option-check">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageContent; 